import { AnyComponent } from "preact";
import { botsRoute, privacyPath, termsPath } from "../../constants.ts";
import { ApiDocs } from "./apiDocs.tsx";
import { Blog, BlogPost } from "./blog.tsx";
import { chatPath } from "./paths.ts";
import { MyBots } from "./bots.tsx";
import { BuilderChat } from "./builderChat.tsx";
import { DebugReportPage } from "./debugReport.tsx";
import { LandingPage } from "./landing.tsx";
import { PrivacyPolicy } from "./privacyPolicy.tsx";
import { LoginPage, loginPath, UpgradePage, WithLogin } from "./login.tsx";
import { PricingPage } from "./pricingPage.tsx";
import { About } from "./about.tsx";
import { RefundPolicy } from "./refundPolicy.tsx";
import { Settings } from "./settings.tsx";
import { TermsOfService } from "./termsOfService.tsx";
import { Unsubscribe } from "./unsubscribe.tsx";
import { TalkToSkill, talkToSkillRoute } from "./talkToSkill.tsx";
import { Agency, agencyRoute, templatesRoute } from "./agency.tsx";
import { AdminPage } from "./admin.tsx";
import { DemoNumbersPage } from "./demoNumbers.tsx";
import { HandoffPage } from "./handoffPage.tsx";
import { MentatPage } from "./mentat.tsx";
import { AutomationPage } from "./automation.tsx";
import { BusinessPage } from "./business.tsx";
import { AgenticUiPage } from "./agenticUi.tsx";
import {
  agenticUiPath,
  automationPath,
  businessPath,
  mentatPath,
} from "./paths.ts";

export const routes: {
  path: string;
  text?: string;
  component: AnyComponent;
}[] = [
  { path: "/", component: LandingPage },
  { path: loginPath, component: LoginPage },
  { path: "/upgrade", component: UpgradePage },
  {
    path: chatPath,
    component: WithLogin(BuilderChat),
    text: "Chat",
  },
  {
    path: "/builder-chat",
    component: WithLogin(BuilderChat),
  },
  { path: botsRoute, component: WithLogin(MyBots), text: "Dashboard" },
  { path: "/settings", component: WithLogin(Settings), text: "Settings" },
  { path: "/profile", component: WithLogin(Settings) },
  {
    path: "/demo-numbers",
    component: WithLogin(DemoNumbersPage),
  },
  { path: "/unsubscribe/:userId/:token", component: Unsubscribe },
  { path: "/handoff/:botId/:conversationId", component: HandoffPage },
  { path: "/debug", component: DebugReportPage },
  { path: "/docs", component: ApiDocs, text: "Docs" },
  { path: "/blog", component: Blog, text: "Blog" },
  { path: "/blog/:slug", component: BlogPost },
  { path: privacyPath, component: PrivacyPolicy },
  { path: "/pricing", component: PricingPage, text: "Pricing" },
  { path: termsPath, component: TermsOfService },
  { path: "/refund-policy", component: RefundPolicy },
  { path: "/about", component: About },
  { path: templatesRoute, component: Agency, text: "Templates" },
  { path: agencyRoute, component: Agency },
  { path: talkToSkillRoute, component: TalkToSkill },
  { path: mentatPath, component: MentatPage },
  { path: automationPath, component: AutomationPage },
  { path: businessPath, component: BusinessPage },
  { path: agenticUiPath, component: AgenticUiPage },
  { path: "/admin", component: WithLogin(AdminPage) },
];
